<template>
    <div class="upload_cls">
        <el-upload
                v-show="uploadflag"
                class="upload-demo"
                action=""
                :before-upload="beforeUpload"
                multiple
                :limit="limit"
                :on-exceed="handleExceed" >
            <el-button class="h-btn h-formBtn h-bgblueQ">上传批复凭证</el-button>
            <div slot="tip" class="el-upload__tip" style="color: #ff2424">{{tips}}</div>
        </el-upload>
        <ul class="el-upload-list el-upload-list--text">
            <li v-for="o,i in this.fileList" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                <a class="el-upload-list__item-name" v-down="o.id"><i
                        class="el-icon-document"></i>{{o.name}}
                </a>    <label class="el-upload-list__item-status-label" v-if="showTime">
                    {{o.cdate}}
                 </label>
                <i @click="delfile(o)" v-show="delflag" class="el-icon-close"></i>
            </li>
        </ul>
    </div>

</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    export default {
        props:{
            refid:null,
            reftype:null,
            limit:{
                type: Number,
                default: 0
            },
            tips:'',
            //是否可以上传
            uploadflag:{
                type: Boolean,
                default: false
            },
            //是否可以删除
            delflag:{
                type: Boolean,
                default: false
            },
            showtime:{
                type:Boolean,
                default:true,
            }
        },
        computed: {
            reftypeVal: function () {
                return this.reftype;
            },
            refidVal:function(){
                    return this.refid;
                },
            showTime:function () {
                return this.showtime;
            }
        },
        watch: {
            refid(val, newval) {
                this.fileList = [];
                this.loadFilelist(val)
            }
        },
        data() {
            return {
                fileList: []
            };
        },
        created() {
            this.loadFilelist(null);
        },
        methods: {
            loadFilelist(refid){
                uploaddown.listdownfile({refid:refid||this.refidVal, reftype: this.reftypeVal}).then(rd => {
                    this.fileList = rd.obj;
                })
            },
            beforeUpload(file){
                if(this.limit!=0 && this.fileList.length>=this.limit){
                    this.$msg.msge("超过文件个数限制,请先删除后再操作!");
                    return false;
                }
                uploaddown.uploadToShowManyPlace(file, {refid: this.refidVal, reftype: this.reftypeVal, flag: this.limit}).then(rd => {
                    this.fileList.unshift(rd.obj)
                    this.$emit('filecallback', this.fileList);
                }).catch(error=>{
                    return Promise.reject(error);
                })
              return false;
            },
            handleExceed(files, fileList) {
                this.$msg.msge("超过文件个数限制");
            },
            delfile(file) {
                if (this.delflag) {
                    this.$msg.confirm("附件删除不可逆，请谨慎操作，确认删除?",()=>{
                        uploaddown.deleteById(file.id).then(rd => {
                            this.fileList = _.reject(this.fileList,{id:file.id})
                            this.$emit('filecallback', this.fileList);
                        })
                    })
                    return true;
                }
                this.$msg.msge("禁止删除附件！")
                return false;
            }
        },

    }
</script>
<style>
    .upload_cls .el-upload-list__item:first-child {
        margin-top: 0px;
    }
    .el-icon-close{
        display: block;
    }
    .el-upload-list__item.is-success .el-upload-list__item-status-label {
         width: auto!important;
         margin-top: 0px!important;
        right: 25px!important;
    }
    .el-upload-list__item .el-icon-close {
        display: block;
    }
    .el-upload-list__item.is-success:active .el-icon-close-tip, .el-upload-list__item.is-success:focus .el-upload-list__item-status-label, .el-upload-list__item.is-success:hover .el-upload-list__item-status-label, .el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip {
        display: block!important;
    }
</style>
